import { POLICY_VERSION } from '../data/legalLinks';

/** Поля согласия для API-запросов с персональными данными. */
export function buildConsentPayload(consent, marketingConsent = false) {
  return {
    consent: consent === true,
    policy_version: POLICY_VERSION,
    marketing_consent: marketingConsent === true,
  };
}
